export const ModalLogOutTranslationsUk = {
  LogOut: 'Ви дійсно бажаєте вийти?',
  yes: 'Так, вийти',
  back: 'Назад',
};
